"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BestowLogrocket = exports.initLogrocket = void 0;
const tslib_1 = require("tslib");
const logrocket_1 = tslib_1.__importDefault(require("logrocket"));
exports.BestowLogrocket = logrocket_1.default;
const keysToSanitize = {
    gender: /gender=([^&]*)/,
    date_of_birth: /date_of_birth=([^&]*)/,
    height: /height=([^&]*)/,
    weight: /weight=([^&]*)/,
    zip: /zip=([^&]*)/,
    tobacco: /tobacco=([^&]*)/,
    ssn: /ssn=([^&]*)/,
};
const initLogrocket = (logRocketAppId) => {
    if (!logRocketAppId) {
        throw new Error("Must pass log rocket App Id");
    }
    logrocket_1.default.init(logRocketAppId, {
        dom: {
            inputSanitizer: true,
        },
        network: {
            requestSanitizer: (request) => {
                request.body = undefined;
                if (request.headers["authorization"]) {
                    request.headers["authorization"] = "**redacted**";
                }
                return request;
            },
            responseSanitizer: (response) => {
                response.body = undefined;
                if (response.headers["authorization"]) {
                    response.headers["authorization"] = "**redacted**";
                }
                return response;
            },
        },
        browser: {
            urlSanitizer: (url) => {
                let sanitizedUrl = url;
                Object.keys(keysToSanitize).forEach(key => {
                    sanitizedUrl = sanitizedUrl.replace(keysToSanitize[key], `${key}=**redacted**`);
                });
                return sanitizedUrl;
            },
        },
    });
};
exports.initLogrocket = initLogrocket;
//# sourceMappingURL=helpers.js.map